import IconButton from 'LuxKit/Button/IconButton'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import Caption from 'LuxKit/Typography/Caption'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useAppDispatch } from 'hooks/reduxHooks'
import { pushWithRegion } from 'actions/NavigationActions'
import { useSelector } from '@xstate/react'
import { MultiCartContext } from 'machines/cart/MultiCartMachineProvider'
import { selectItemsInActiveCart } from 'machines/cart/selectors'

const StyledNotificationIconButton = styled(IconButton)`
  position: relative;
`

const RedDotOnSignUp = styled(Caption)`
  position: absolute;
  top: ${rem(2)};
  right: ${rem(2)};
  padding: ${rem(2)} ${rem(4)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.messaging.critical.normalBackground};
  color: ${props => props.theme.palette.messaging.critical.normalContrast};
`

function MultiCartHeader() {
  const dispatch = useAppDispatch()

  const onClickCart = useCallback(() => {
    dispatch(pushWithRegion('/cart'))
  }, [dispatch])

  const multiCartActorRef = MultiCartContext.useActorRef()
  const cartItems = useSelector(multiCartActorRef, (snapshot) => {
    return selectItemsInActiveCart(snapshot).filter(item => item.state === 'active' && item.status === 'available').length
  })

  return <StyledNotificationIconButton
    kind="tertiary"
    variant="default"
    role="menuitem"
    onClick={onClickCart}
  >
    <LineShoppingCartIcon />
    {cartItems > 0 && <RedDotOnSignUp variant="small">
      {cartItems > 9 ? '9+' : cartItems}
    </RedDotOnSignUp>}
  </StyledNotificationIconButton>
}

export default MultiCartHeader
